export default __webpack_public_path__ + "static/media/ACZINO.102f4c7e.png";